import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../subscriptionform/Subscription.css';
import useApi from '../../customHook/useApi';
import { toast } from 'react-toastify';

// Stripe 
import { loadStripe } from '@stripe/stripe-js';
import { PaymentElement, Elements, useStripe, useElements } from '@stripe/react-stripe-js';

// Stripe public key
const stripePromise = loadStripe("pk_test_51QlT13KSg4AolB032kPhN6lS7U0chPJiy6unw4ZBYNm84WjHzCCZz0Os2BoLNnOvy039Qv1G9loxIMdEO6r6pDGN00mYwPvB2l");

const Subscription = () => {
    const navigate = useNavigate();
    const { get } = useApi('https://codezens.com/luststory/index.php/api'); // API base URL
    const [plans, setPlans] = useState([]);
    const [selectedPlan, setSelectedPlan] = useState(null);
    const [clientSecret, setClientSecret] = useState(null);

    // Fetch plans on component mount
    useEffect(() => {
        const fetchPlan = async () => {
            try {
                const response = await get('/get_plans');
                setPlans(response.result);
            } catch (err) {
                console.error(err);
            }
        };
        fetchPlan();
    }, [get]);

    // Handle plan selection
    const handlePlanSelect = (plan) => {
        setSelectedPlan(plan);
    };

    // !====================================================== Stripe Intigration start ============================================
    // Handle payment initialization
    const handlePayment = async () => {
        if (!selectedPlan) {
            toast.error('Please select a plan');
            return;
        }
        try {
            const response = await fetch('http://localhost:5000/api/create-payment-intent', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({

                    amount: selectedPlan.amount,
                    currency: "INR",
                    // currency: "usd",
                    plan_id: selectedPlan.plan_id,
                }),
            });
            const result = await response.json();
            if (!result.clientSecret) {
                alert(result.message);
            }
            setClientSecret(result.clientSecret);
        } catch (error) {
            console.error('Error initiating payment:', error);
            toast.error('Failed to initiate payment');
        }
    };

    // Stripe options
    const stripeOptions = { clientSecret, appearance: { theme: 'stripe' } };

    // Stripe Checkout Form-
    const CheckoutForm = () => {
        const stripe = useStripe();
        const elements = useElements();
        const [errorMessage, setErrorMessage] = useState(null);

        const handleSubmit = async (event) => {
            event.preventDefault();
            if (!stripe || !elements) {
                return;
            }
            const result = await stripe.confirmPayment({
                elements,
                confirmParams: {
                    return_url: 'http://localhost:3000/setup-your-profile',

                },
                redirect: "if_required",
            });

            if (result.paymentIntent && result.paymentIntent.status === "succeeded") {
                // alert("Payment Successful! Redirecting...");
                toast.success('Payment Successsfull!');
                navigate('/setup-your-profile');
            } else if (result.error) {
                setErrorMessage(result.error.message);
            }
        };

        return (
            <form onSubmit={handleSubmit}>
                <PaymentElement />
                <div className="d-flex align-items-center justify-content-center" style={{ height: "10vh" }}>
                    <button type="submit" className="btn btn-primary mt-4" disabled={!stripe || !elements}>Pay</button>
                </div>
                {errorMessage && <div className="text-danger mt-3">{errorMessage}</div>}
            </form>
        );
    };

    return (
        <div className="subscription-section w-100 position-relative">
            <Link to="/signup" className="back-btn">Back</Link>
            <div className='subscription-box d-flex flex-wrap align-content-center justify-content-center '>
                <div className='inner-subscription d-flex flex-wrap align-content-center justify-content-center'>
                    <div className='subscription-form w-100'>
                        <h6>Subscription</h6>
                        <div className='select-box-sec'>
                            {plans.map((plan) => {
                                return <div key={plan.plan_id} className='select-box mb-2 d-flex justify-content-between align-items-center'>
                                    <div className='left-select d-flex align-items-center gap-3'>
                                        <span>{plan.name} </span>
                                        <span>${plan.amount}</span>
                                    </div>
                                    <div className='right-select'>
                                        <button rel='stylesheet' onClick={() => handlePlanSelect(plan)} className='btn btn-border'>{selectedPlan?.plan_id === plan.plan_id ? 'Selected' : 'Select'}</button>
                                    </div>
                                </div>
                            })}
                            <p className='mb-0'>*Cancel anytime with no fees! </p>
                        </div>

                        <div className='t-and-c-box'>
                            <h6>Terms and Conditions</h6>
                            <div className='form-box'>
                                <textarea className="form-control" id="" rows="5"></textarea>
                            </div>
                            <div className='radio-box-checked p-0 m-0'>
                                <div className="form-check">
                                    <input className="form-check-input" type="radio" name="exampleRadios2" id="" value="option2" />
                                    <label className="form-check-label" for="">I have read and accept the terms and conditions</label>
                                </div>
                            </div>
                        </div>
                        {/* <p className='text-center mt-4'><Link rel='stylesheet' to="/setup-your-profile">Next</Link></p> */}
                        <p className='text-center mt-4 cursor-pointer ' data-bs-toggle="modal" data-bs-target="#exampleModal" onClick={handlePayment}>Pay</p>
                    </div>
                </div>
            </div>

            {/* Payment Modal */}

            <div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Complete Payment</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            {clientSecret && (
                                <Elements stripe={stripePromise} options={stripeOptions}>
                                    <CheckoutForm />
                                </Elements>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Subscription;
